import * as React from "react";
import { DropdownButton } from "components/bootstrap";
import Icon from "./Icon";
export const MoreActionsIcon = ({ size = void 0 }) => /* @__PURE__ */ React.createElement(Icon, { name: "more_horiz", size });
export const MoreActionsMenu = ({
  "aria-label": ariaLabel,
  size = "xs",
  children = void 0,
  className = void 0,
  id = void 0,
  keepMounted = void 0,
  pullRight = void 0,
  title = "More Actions",
  solid = false
}) => /* @__PURE__ */ React.createElement(
  DropdownButton,
  {
    "aria-label": ariaLabel,
    bsStyle: solid ? void 0 : "transparent",
    buttonTitle: title,
    className,
    id,
    keepMounted,
    noCaret: true,
    pullRight,
    title: /* @__PURE__ */ React.createElement(MoreActionsIcon, { size }),
    withinPortal: true
  },
  children
);
